// src/app/report-fallback.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { HttpContextToken } from '@angular/common/http';

export const SKIP_FALLBACK_TO_PACKAGE_ENDPOINT = new HttpContextToken<boolean>(() => false);

const isParticipantReportDownload = (url: string) => /\/downloadreport(\b|\/)/.test(url); // adjust if your segment differs

const toPackageUrl = (url: string) => url.replace('/downloadreport', '/downloadpackage'); // adjust to your package route

export const reportFallbackInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((err) => {
      const shouldFallback =
        err instanceof HttpErrorResponse &&
        err.status === 404 &&
        isParticipantReportDownload(req.url);

      if (shouldFallback == false || req.context.get(SKIP_FALLBACK_TO_PACKAGE_ENDPOINT) == true) {
        console.log('skipping fallback for url: ', req.url, isParticipantReportDownload(req.url));
        return throwError(() => err);
      }

      const fallbackUrl = toPackageUrl(req.url);
      const fallbackReq = req.clone({ url: fallbackUrl });
      // Re-dispatch with the package endpoint
      console.log('falling back to package url: ', fallbackUrl);
      return next(fallbackReq);
    }),
  );
};
